import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'

import FlashMessage from './FlashMessage'
import Shortcut from './Notifications.shortcut'
import NotificationsBoard from './Notifications.board'

class Notifications extends PureComponent {
    static propTypes = {
        flashMessages: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                message: PropTypes.string,
            })
        ),
        messages: PropTypes.arrayOf(PropTypes.shape({})),
        onDismiss: PropTypes.func.isRequired,
        onDismissAll: PropTypes.func.isRequired,
        onDismissFlash: PropTypes.func.isRequired,
        setDisplay: PropTypes.func,
    }

    static defaultProps = {
        flashMessages: [],
        messages: [],
        setDisplay: () => undefined,
    }

    constructor(props) {
        super(props)

        this.state = {
            isBoardOpen: false,
        }

        this.onClickShortcut = this.onClickShortcut.bind(this)
    }

    onClickShortcut() {
        const { isBoardOpen } = this.state
        const {setDisplay} = this.props
        this.setState({ isBoardOpen: !isBoardOpen })
        setDisplay(false)
    }

    render() {
        const { flashMessages, messages, onDismiss, onDismissAll, onDismissFlash } = this.props
        const { isBoardOpen } = this.state
        const displayFlashMessage = !!flashMessages.length
        const { id: flashId, message: flashMessage } = displayFlashMessage ? flashMessages[0] : {}

        return (
            <Fragment>
                <Shortcut onClick={this.onClickShortcut} withAlert={!!messages.length}/>
                <NotificationsBoard onClose={this.onClickShortcut} onDismiss={onDismiss} onDismissAll={onDismissAll} open={isBoardOpen} messages={messages} />
                {displayFlashMessage && (
                    <FlashMessage id={flashId} onDismissFlash={onDismissFlash}>
                        {flashMessage}
                    </FlashMessage>
                )}
            </Fragment>
        )
    }
}
export default Notifications
